import heatmap from "./heatmap.component";

const heatmapModule = angular
  .module("app.components.heatmap", [])
  .component("heatmap", heatmap);

export default heatmapModule;



// WEBPACK FOOTER //
// ./src/components/heatmap/heatmap.module.js